import { AppModal } from 'shared/UI/UIKit/Modal';
import { MaxLessonsPerDayForm } from 'entities/max-lessons-per-day/form';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppEditIcon } from 'shared/UI/UIKit/icons/Edit';
import type { MaxLessonsPerDay } from 'shared/api';
import { useMaxLessonsPerDayEdit } from '../model';
import styles from './styles.module.scss';

interface MaxLessonsPerDayEditProps {
  maxLessonsPerDay: MaxLessonsPerDay;
  refreshTable: () => void;
}

export const MaxLessonsPerDayEdit = ({
  maxLessonsPerDay,
  refreshTable,
}: MaxLessonsPerDayEditProps) => {
  const {
    state: { modalVisible, form },
    methods: { showModal, hideModal, onSubmit },
  } = useMaxLessonsPerDayEdit({ maxLessonsPerDay, refreshTable });

  return (
    <>
      <AppEditIcon className={styles.icon} onClick={showModal} />

      <AppModal
        content={<MaxLessonsPerDayForm form={form} />}
        title="Редактирование конфигурации"
        visible={modalVisible}
        onCancel={hideModal}
        destroyOnClose
        footer={
          <AppFlex direction="row">
            <AppButton type="primary" onClick={onSubmit}>
              Сохранить
            </AppButton>
            <AppButton type="outline" onClick={hideModal}>
              Закрыть
            </AppButton>
          </AppFlex>
        }
      />
    </>
  );
};
